import { render, staticRenderFns } from "./Wp_tabbar_for_client.vue?vue&type=template&id=66921a44&scoped=true&"
import script from "./Wp_tabbar_for_client.vue?vue&type=script&lang=js&"
export * from "./Wp_tabbar_for_client.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66921a44",
  null
  
)

export default component.exports